import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import dexConfigReducer from './dexConfigSlice';
import logReducer from './slices/logSlice';

/**
 * Redux持久化配置
 */
const persistConfig = {
  key: 'dexServiceConfig', // 使用与手动操作相同的键名
  storage,
  whitelist: ['dexConfig'] // 只持久化dexConfig
};

/**
 * 合并所有reducer
 */
const rootReducer = combineReducers({
  dexConfig: dexConfigReducer,
  log: logReducer
});

/**
 * 持久化reducer
 */
const persistedReducer = persistReducer(persistConfig, rootReducer);

/**
 * 创建Redux store
 */
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false // 关闭序列化检查，因为redux-persist会使用非序列化值
    })
});

/**
 * 创建持久化store
 */
export const persistor = persistStore(store);

/**
 * 导出RootState类型
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * 导出AppDispatch类型
 */
export type AppDispatch = typeof store.dispatch;
